import { createApp, ref } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import { createPinia } from 'pinia'

import 'plyr-vue/dist/plyr-vue.css'
import 'aos/dist/aos.css'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import '@splidejs/splide/dist/css/splide.min.css'

import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import Toast from 'vue-toastification'
import '@/disttoast/index.css'

import AOS from 'aos'

import { i18n } from '@/plugins/i18n'

// PWA service worker
import './registerServiceWorker'

// ==============================
// Nexgbits Client Platform - PWA
// ==============================


import offlineManager from '@/platform/pwa/offlineManager'
import installManager from '@/platform/pwa/installManager'
import notificationManager from '@/platform/pwa/notificationManager'

import updateDialog from '@/platform/ui/updateDialog'
import installPrompt from '@/platform/ui/installPrompt'
import offlineBanner from '@/platform/ui/offlineBanner'
import splashScreen from '@/platform/ui/splashScreen'
import cacheManager from '@/platform/storage/cacheManager'

import indexedDb from '@/platform/storage/indexedDb'
import syncQueue from '@/platform/storage/syncQueue'

import {
  configuration
} from '@/platform/core'


// ==============================
// Existing application setup
// ==============================

loadFonts()

const app = createApp(App)
const pinia = createPinia()
const locale = ref('')

AOS.init()

// window.cacheManager = cacheManager
// window.syncQueue = syncQueue
// ==============================
// Nexgbits Client Platform
// Initialization
// ==============================

configuration.init()

offlineManager.init()
installManager.init()
notificationManager.init()

updateDialog.init()
installPrompt.init()
offlineBanner.init()

splashScreen.init({
  minimumDisplayMs: 500
})

indexedDb
  .open()
  .then(() => {
    syncQueue.init()
  })
  .catch(error => {
    console.error(
      '[Platform] Failed to initialize IndexedDB:',
      error
    )
  })
// ==============================
// Existing ResizeObserver handling
// ==============================

window.addEventListener(
  'error',
  e => {
    if (
      e.message?.includes(
        'ResizeObserver loop'
      )
    ) {
      e.stopImmediatePropagation()
    }
  }
)


// ==============================
// Existing Vue plugins
// ==============================

// app.use(axios)

app.use(router)

app.use(store)

app.use(i18n)

app.use(pinia)

app.use(
  Toast,
  {
    position: 'top-right',
    timeout: 3000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  }
)

app.use(vuetify)


// ==============================
// Mount application
// ==============================

app.mount('#app')